const clean = (value) => {
  const text = String(value || '').trim();
  return text && text.toLowerCase() !== 'n/a' ? text : '';
};

const splitFullAddress = (value) => {
  const text = clean(value);
  const match = text.match(/^(.*?),\s*(\d{4})\s+(.+)$/);
  if (!match) return { street: text, postalCode: '', city: '' };
  return { street: clean(match[1]), postalCode: match[2], city: clean(match[3]) };
};

const splitZipCity = (value) => {
  const text = clean(value);
  const match = text.match(/^(\d{4})(?:\s+(.+))?$/);
  return match
    ? { postalCode: match[1], city: clean(match[2]) }
    : { postalCode: '', city: text };
};

/**
 * Resolve the immutable customer address snapshot stored on a repair process.
 * Actor addresses are intentionally not accepted here: an actor may book again
 * or edit their default address, but an existing repair must keep its own
 * collection/drop-off destination.
 */
export const resolveProcessCustomerAddress = (customer = {}) => {
  // API list responses may temporarily contain an explicit null customer while
  // actor/process metadata is still being loaded. Default parameters only cover
  // undefined, so normalize every non-object value before reading its fields.
  const snapshot = customer && typeof customer === 'object' ? customer : {};
  const addresses = Array.isArray(snapshot.addresses) ? snapshot.addresses : [];
  const saved = addresses.find((address) => address?.is_default) || addresses[0] || {};
  const direct = splitFullAddress(snapshot.address);
  const zipCity = splitZipCity(snapshot.zip_city);

  const result = {
    street: clean(saved.street) || direct.street,
    postalCode: clean(saved.postal_code) || clean(snapshot.postal_code) || clean(snapshot.zip) || direct.postalCode || zipCity.postalCode,
    city: clean(saved.city) || clean(snapshot.city) || direct.city || zipCity.city,
    state: clean(saved.state) || clean(snapshot.state) || clean(snapshot.canton),
    country: clean(saved.country) || clean(snapshot.country),
  };

  return Object.values(result).some(Boolean) ? result : null;
};

export const formatProcessCustomerAddress = (customer = {}) => {
  const address = resolveProcessCustomerAddress(customer);
  if (!address) return '';
  const parts = [];
  if (address.street) parts.push(address.street);
  const cityLine = [address.postalCode, address.city].filter(Boolean).join(' ');
  if (cityLine) parts.push(cityLine);
  return parts.join(', ');
};
